<template>
	<SIcon name="shared-with-me" :width="8" />
</template>

<script>
export default { name: 'SharedWithMeIcon' };
</script>
